import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = { autoOpen: Boolean }

  connect() {
    this.element.dataset.modalReady = "true"
    if (this.autoOpenValue) this.open()
  }

  disconnect() {
    delete this.element.dataset.modalReady
  }

  open() {
    if (!this.modalTarget.open) this.modalTarget.showModal()
  }

  close() {
    if (this.modalTarget.open) this.modalTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  trapFocus(event) {
    if (event.key !== "Tab") return

    const focusable = Array.from(this.modalTarget.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(element => element.getClientRects().length > 0)
    const first = focusable[0]
    const last = focusable.at(-1)

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  didClose() {
    if (!this.modalTarget.querySelector("[data-controller~='dropzone']")) return

    window.dispatchEvent(new CustomEvent("upload-surface:close"))
  }
}
